import { Injectable } from '@angular/core';

import { GraphQLService } from '@app/services';
import { queryLead } from '@app/graphql-queries';

@Injectable({
  providedIn: 'root'
})
export class LeadService {
    
    constructor(
        private graphQLService: GraphQLService
    ) { }
    
    async fetchLead(leadID: string) : Promise<any|null> {
        let lead: any|null = null;
        let response = await this.graphQLService.query({            
            query: queryLead,
            variables: {
                ID: leadID
            }
        }, 'public');              
        if(response?.data?.Lead){
            lead = response.data.Lead;
        }
        return lead;
    }
    
}
